import React, { FC } from "react";
import styled from "styled-components";
import { FlagAndNoteProps } from "../common/types";
import { Button } from "../../button/Button";

const Flag = styled.div`
  margin-top: 10px;
  font-weight: 500;

  &,
  button {
    font-size: 14px;
    color: ${({ theme }) => theme.color.error};
  }
`;

const Note = styled.div`
  font-size: 12px;
`;

export const FlagAndNote: FC<FlagAndNoteProps> = ({
  product,
  quantity,
  inventoryQty,
  blockedItem,
  updateCartItem,
  subscriptionIntervalInDays,
  isGuest,
}) => {
  const handleUpdateQty = () => {
    if (!product.id || !product.inventoryQty) return;
    updateCartItem({
      productId: product.id,
      quantity: product.inventoryQty,
      subscriptionIntervalInDays,
    });
  };

  const outOfStock =
    product.isOutOfStock || !inventoryQty || blockedItem?.isOutOfStock;
  const lowStock =
    (!!inventoryQty && quantity > inventoryQty) ||
    (blockedItem?.isLowStock && !!blockedItem?.inventoryQty);
  const remainingInventory = blockedItem?.inventoryQty || inventoryQty;

  if (outOfStock) {
    return (
      <>
        <Flag>Currently unavailable</Flag>
        <Note>
          This product is unavailable due to inventory. Please remove this
          product to proceed.
        </Note>
      </>
    );
  }

  if (lowStock) {
    return (
      <>
        <Flag>
          <Button type="text" onClick={handleUpdateQty}>
            Only {remainingInventory} Available
          </Button>
        </Flag>

        <Note>
          Please update the quantity for this item or remove it from your cart
          to proceed.
        </Note>
      </>
    );
  }

  if (blockedItem) {
    return (
      <>
        <Flag>Currently unavailable</Flag>
        <Note>
          This product is unavailable
          {blockedItem.isZipError ? " in your region/zip code" : ""}. Please
          remove this product from your cart to complete your order.
        </Note>
      </>
    );
  }

  if (subscriptionIntervalInDays && isGuest) {
    return (
      <>
        <Flag>Subscription unavailable</Flag>
        <Note>
          Product subscriptions are only available by registering for an
          account. Please remove this product from your cart to proceed.
        </Note>
      </>
    );
  }

  return null;
};
